import { render, staticRenderFns } from "./ProductTypes.vue?vue&type=template&id=50da7a7e&scoped=true&"
import script from "./ProductTypes.vue?vue&type=script&lang=js&"
export * from "./ProductTypes.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypes.vue?vue&type=style&index=0&id=50da7a7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da7a7e",
  null
  
)

export default component.exports